<div id="vision-mission" class="pt-5">
  <div class="container">
    <div class="content-box">
      <div class="row" data-scroll>
        
        <div class="col-12 col-md-4">
          <h2 class="home-title mt-0">SSJG <span style="color: var(--orange);">College</span></h2>
          <p>Shah Satnam Ji Girls' College Sirsa is a name synonymous with quality and excellence not only in academics but also in sports, cultural programs, decorum, social and ecological concerns, and spiritual and ethical values.</p>
        </div>

        <div class="col-12 col-md-8">
          <div class="row">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active" id="who-btn" data-bs-toggle="collapse"
                  data-bs-target="#who" (click)="showCard(1)">
                  <i class="fa-solid fa-eye"></i> &nbsp;Who We Are
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="founder-btn" data-bs-toggle="collapse"
                  data-bs-target="#founder" (click)="showCard(2)">
                  <i class="fa-solid fa-earth-americas"></i> &nbsp;The Founder
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="inspiration-btn" data-bs-toggle="collapse"
                  data-bs-target="#inspiration" (click)="showCard(3)">
                  <i class="fa-solid fa-trophy"></i> &nbsp;Our Inspiration
                </a>
              </li>
            </ul>
          </div>

          <div class="row collapse" id="who">
            <p class="mt-3">Shah Satnam Ji Girls’ College is dedicated to realizing the essence of being human. We strive to uphold humanity as our guiding principle, emphasizing the importance of kindness, empathy, and social responsibility..... 
              <a routerLink="/about" style="color: #ffff;text-decoration: none;  font-weight: bold;">Read More</a>
            </p>
          </div>

          <div class="row collapse" id="founder">
            <p class="mt-3">Established in 1997, by Saint Dr.Gurmeet Ram Rahim Singh ji Insan, it has emerged as a leading institution in Haryana dedicated to advancing Girls’ Education, particularly among underprivileged communities in rural, semi-urban, and urban areas.... 
              <a routerLink="/about/founder" style="color: #ffff;text-decoration: none; font-weight: bold;" >Read More</a>
            </p>
          </div>

          <div class="row collapse" id="inspiration">
            <p class="mt-3">At Shah Satnam Ji Girls’ College, we believe in MSG- the magnificent sagaciousness and glistening power of our learners. Our institute stands as a beacon of academic excellence, innovation, and community involvement...
              <a routerLink="/about/inspiration" style="color: #ffff;text-decoration: none;  font-weight: bold;">Read More</a>
            </p>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
